import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const NoticeManagementPageLayout = (props: Props) => {
    return (
        <><Outlet /></>
    );
};

export default NoticeManagementPageLayout;
